<template>
  <div class="container">
    <h1 class="py-4">BANKIT-Choysanユーザサマリ</h1>
    <h3 class="py-4">{{ year }}年{{ month }}月</h3>
    <div>
      <div class="form-row">
        <div class="form-group col-md-auto">
          <vue-json-to-csv
            :labels="this.csvCurrentFields"
            :json-data="this.csvData"
            :csv-title="this.fileName"
          >
            <button class="btn btn-success">
              CSV ダウンロード
            </button>
          </vue-json-to-csv>
        </div>
      </div>
      <div class="text-right">
        <p>{{ created_at }}</p>
      </div>
      <div v-if="loading" class="form-row">
        <b-spinner
          class="autoMarginLR"
          variant="primary"
          label="Spinning"
        ></b-spinner>
      </div>
      <div v-if="!loading" class="table-responsive">
        <b-table
          id="dataTable"
          :items="tableData"
          :per-page="perPage"
          :current-page="currentPage"
          :fields="fields"
        >
          <template #cell(PID)="data">
            <router-link
              :to="{
                name: 'UserSummaryList',
                query: {
                  pid: data.item.PID,
                  partnerName: data.item.パートナー名,
                  card_type_id: data.item.card_type_id,
                  year: year,
                  month: month,
                },
              }"
              >{{ data.item.PID }}</router-link
            >
          </template>
          <template #head(登録数)>
            <div class="alignRight">登録数</div>
          </template>
          <template #head(累計登録数)>
            <div class="alignRight">累計登録数</div>
          </template>
          <template #cell(登録数)="data">
            <p class="alignRight">{{ data.item.登録数 }}</p>
          </template>
          <template #cell(累計登録数)="data">
            <p class="alignRight">{{ data.item.累計登録数 }}</p>
          </template>
        </b-table>
        <b-pagination
          class="mt30"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          align="right"
          aria-controls="dataTable"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import master from "@/constants/MasterEnum";
import utils from "@/utils/Utils";
import firebase from "firebase";
import VueJsonToCsv from "vue-json-to-csv";

export default {
  name: "UserRegistrationSummaryDetails",
  mixins: [utils, master],
  computed: {
    rows() {
      return this.tableData.length;
    },
  },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      year: "",
      month: "",
      db: firebase.firestore(),
      tableData: [],
      fields: ["PID", "パートナー名", "カード種類", "登録数", "累計登録数"],
      loading: true,
      csvCurrentFields: {},
      fileName: "",
      csvData: [],
      created_at: "",
    };
  },
  components: {
    VueJsonToCsv,
  },
  created: function() {
    this.month = this.$route.query.month;
    this.year = this.$route.query.year;
    this.loading = true;
    this.fileName =
      this.tsvFormat.userSummary.fileName + "-" + this.year + "-" + this.month;
    this.csvCurrentFields = this.tsvFormat.userSummary.labels;
    this.loadData();
  },
  methods: {
    async loadData() {
      const query = this.db
        .collection("batchUsers")
        .where("year", "==", parseInt(this.year))
        .where("month", "==", parseInt(this.month))
        .orderBy("pid");

      const snapshot = await query.get();
      if (snapshot.docs[0] !== undefined) {
        this.created_at =
          this.$moment(snapshot.docs[0].data().created_at.toDate()).format(
            "YYYY/MM/DD HH:mm:ss"
          ) + " 集計";
      }
      snapshot.forEach(async (doc) => {
        let data = doc.data();
        let tableItem = {
          created_at: data.created,
          PID: data.pid,
          パートナー名: data.partnerName,
          カード種類: data.card_type,
          登録数: data.activeMonthRegistration,
          card_type_id: data.card_type,
          累計登録数: data.total,
        };
        let cardTypeText = this.card_type_codes[data.card_type];
        if (cardTypeText !== undefined) {
          tableItem.カード種類 = cardTypeText;
        }
        if (data.activeMonthRegistration !== 0) {
          this.tableData.push(tableItem);
          this.csvData.push(tableItem);
        }
      });
      this.loading = false;
    },
  },
};
</script>